/* POGO size guide: native dialog provides Escape, focus trapping and focus restoration. */
(() => {
  if (customElements.get('pogo-size-guide')) return;
  customElements.define('pogo-size-guide', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.addEventListener('click', (event) => {
        const dialog = this.querySelector('dialog');
        if (!dialog || !(event.target instanceof Element)) return;
        if (event.target.closest('[data-pogo-guide-open]')) {
          if (!dialog.open) dialog.showModal();
        } else if (event.target.closest('[data-pogo-guide-close]')) {
          dialog.close();
        } else if (event.target === dialog) {
          const bounds = dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
        }
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() { this.querySelector('dialog')?.close(); this.controller?.abort(); }
  });
})();
